import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type ContragentListItemDTO = {
  id: string
  external_id?: string
  full_name: string
  short_name?: string
  country_code?: string
  nip?: string
  roles: string[]
  status: "ACTIVE" | "ARCHIVED"
  created_at: string
}

export type ContragentListResponseDTO = {
  items: ContragentListItemDTO[]
  total: number
  page: number
  page_size: number
}

export type ContragentStatsDTO = {
  total: number
  active: number
  archived: number
  added_30_days: number
}

export const ContragentListApi = {
  getContragentListPage: (params?: {
    search?: string
    status?: string
    role?: string
    page?: number
    page_size?: number
    sort_by?: "full_name" | "short_name" | "nip" | "created_at"
    sort_dir?: "asc" | "desc"
  }): CancelablePromise<ContragentListResponseDTO> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/contragents/list",
      query: params ?? {},
    }),

  getStats: (): CancelablePromise<ContragentStatsDTO> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/contragents/stats",
    }),
}
